// extracted by mini-css-extract-plugin
export default {"detailLight":"Hud_detailLight__EU2C6","detailDark":"Hud_detailDark__dTF78"};